export enum ExtraUnitType {
  HOUR = 'HOUR',
  RESERVATION = 'RESERVATION',
  HEAD_COUNT = 'HEAD_COUNT',
  HOUR_RATE = 'HOUR_RATE',
  DAY = 'DAY',
  WEEK = 'WEEK',
}
